// import mockSchools from '../data/schools';
import axios from "axios";
import CONSTANTS from "../../settings/constants";
import { getCookie } from "@/mixins/cookies";
import features from "../../features.json";

/* eslint no-console: "off" */
const fetchSchools = () => {
  return new Promise(function(resolve) {
    // let schoolsApi = `${CONSTANTS.MIDDLEWARE}/schools`
    let schoolsApi = `${CONSTANTS.MIDDLEWARE}/schools`;
    //eslint-disable-next-line
    NativeJS.debugLog(`Calling ${schoolsApi}`);
    let start = Date.now();
    axios
      .get(schoolsApi)
      .then(response => {
        let end = Date.now();
        let time = (end - start) / 1000;
        //eslint-disable-next-line
        NativeJS.debugLog(
          `${schoolsApi} responded after ${time} seconds with a ${response.status} code`
        );
        //eslint-disable-next-line
        NativeJS.debugLog(
          `${schoolsApi} Response body: ${JSON.stringify(
            response.data,
            null,
            2
          )}`
        );
        resolve(response.data);
      })
      .catch(error => {
        //eslint-disable-next-line
        NativeJS.debugLog(
          `error calling ${schoolsApi}: ${JSON.stringify(error, null, 2)}`
        );
      });
  });
};

const selectSchool = code => {
  return new Promise(function(resolve, reject) {
    let schoolDetailsApi = `${CONSTANTS.MIDDLEWARE}/schools/details?school_code=${code}`;
    //eslint-disable-next-line
    NativeJS.debugLog(`Calling ${schoolDetailsApi}`);
    let start = Date.now();
    axios
      .get(schoolDetailsApi)
      .then(response => {
        let end = Date.now();
        let time = (end - start) / 1000;
        //eslint-disable-next-line
        NativeJS.debugLog(
          `${schoolDetailsApi} responded after ${time} seconds with a ${response.status} code`
        );
        //eslint-disable-next-line
        NativeJS.debugLog(
          `${schoolDetailsApi} Response body: ${JSON.stringify(
            response.data,
            null,
            2
          )}`
        );
        resolve(response.data);
      })
      .catch(error => {
        //eslint-disable-next-line
        NativeJS.debugLog(
          `error calling ${schoolDetailsApi}: ${JSON.stringify(error, null, 2)}`
        );
        reject(error);
      });
  });
};

const getSchoolStatus = appID => {
  return new Promise(function(resolve) {
    let watchApi = `${CONSTANTS.SCHOOL_STATUS}/watch`;

    let config = {
      headers: {
        token: appID
      }
    };
    //eslint-disable-next-line
    NativeJS.debugLog(
      `Calling GET ${watchApi} with headers: ${config.headers}`
    );
    let start = Date.now();
    axios
      .get(watchApi, config)
      .then(response => {
        let end = Date.now();
        let time = (end - start) / 1000;
        //eslint-disable-next-line
        NativeJS.debugLog(
          `GET ${watchApi} responded after ${time} seconds with a ${response.status} code`
        );
        //eslint-disable-next-line
        NativeJS.debugLog(
          `GET ${watchApi} Response body: ${JSON.stringify(
            response.data,
            null,
            2
          )}`
        );
        resolve(response.data);
      })
      .catch(error => {
        //eslint-disable-next-line
        NativeJS.debugLog(
          `error calling GET ${watchApi}: ${JSON.stringify(error, null, 2)}`
        );
      });
  });
};

const addSchoolStatus = (appID, code) => {
  return new Promise(function(resolve) {
    let watchApi = `${CONSTANTS.SCHOOL_STATUS}/watch`;

    let data = {
      code: String(code)
    };
    let config = {
      headers: {
        token: appID
      }
    };
    //eslint-disable-next-line
    NativeJS.debugLog(
      `Calling PUT ${watchApi} for ${code} with data: ${JSON.stringify(
        data,
        null,
        2
      )} and headers: ${JSON.stringify(config.headers, null, 2)}`
    );
    let start = Date.now();
    axios
      .put(watchApi, data, config)
      .then(response => {
        let end = Date.now();
        let time = (end - start) / 1000;
        //eslint-disable-next-line
        NativeJS.debugLog(
          `PUT ${watchApi} responded after ${time} seconds with a ${response.status} code for ${code}`
        );
        //eslint-disable-next-line
        NativeJS.debugLog(
          `PUT ${watchApi} Response body: ${JSON.stringify(
            response.data,
            null,
            2
          )}`
        );
        resolve(response.data);
      })
      .catch(error => {
        //eslint-disable-next-line
        NativeJS.debugLog(
          `error calling PUT ${watchApi}: ${JSON.stringify(error, null, 2)}`
        );
      });
  });
};

const registerAllSchools = (appID, schools) => {
  schools.forEach(school => {
    if (typeof school.pushNotifications === "boolean") {
      // backwards compatibility: converts previous single boolean to an object with general as the previous value
      const value = school.pushNotifications;
      school.pushNotifications = {
        general: value
      };
      //eslint-disable-next-line
      NativeJS.unsubscribeTopic(id, "general");
    }

    addSchoolStatus(appID, school.schoolCode).then(() => {
      if (
        parseInt(getCookie("appbuild")) >= features.nonMandatoryNotification
      ) {
        ["news", "event", "newsletter", "reminder"].forEach(topic => {
          if (school.pushNotifications[topic] === undefined) {
            school.pushNotifications[topic] = school.pushNotifications.general;
          }
          if (school.pushNotifications[topic]) {
            //eslint-disable-next-line
            NativeJS.subscribeTopic(school.schoolId, topic);
          }
        });
      } else {
        //eslint-disable-next-line
        NativeJS.subscribeTopic(school.schoolId, "general");
      }
    });
  });
};

const removeSchoolStatus = (appID, code, schoolId) => {
  return new Promise(function(resolve) {
    let watchApi = `${CONSTANTS.SCHOOL_STATUS}/watch`;

    let data = {
      code: String(code)
    };
    let headers = {
      token: appID
    };
    //eslint-disable-next-line
    NativeJS.debugLog(
      `Calling DELETE ${watchApi} with data: ${data} and headers: ${headers}`
    );
    let start = Date.now();
    axios
      .delete(watchApi, { data: data, headers: headers })
      .then(response => {
        let end = Date.now();
        let time = (end - start) / 1000;
        //eslint-disable-next-line
        NativeJS.debugLog(
          `DELETE ${watchApi} responded after ${time} seconds with a ${response.status} code`
        );
        //eslint-disable-next-line
        NativeJS.debugLog(
          `DELETE ${watchApi} Response body: ${JSON.stringify(
            response.data,
            null,
            2
          )}`
        );
        //eslint-disable-next-line
        NativeJS.unsubscribeTopic(schoolId);
        resolve(response.data);
      })
      .catch(error => {
        //eslint-disable-next-line
        NativeJS.debugLog(
          `error calling DELETE ${watchApi}: ${JSON.stringify(error, null, 2)}`
        );
      });
  });
};

export default {
  fetchSchools,
  selectSchool,
  getSchoolStatus,
  addSchoolStatus,
  registerAllSchools,
  removeSchoolStatus
};
